import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';

export const initialState = '';

export const fetchShippingRegion = createAsyncThunk<{data: {region: string}}>(
    'CHECKOUT@FETCH_SHIPPING_REGION',
    () =>
        apiConfig.instanceGusaBackend.request({
            method: 'get',
            url: `${ENDPOINTS.CHECKOUT_GET_SHIPPING_REGION}`,
        }),
);

export const cleanShippingRegion = createAction('CHECKOUT@CLEAN_SHIPPING_REGION');

/**
 * Shipping region
 *
 * @return {string} shipping region
 */
export const shippingRegion = createReducer(initialState, builder => {
    builder
        .addCase(cleanShippingRegion, () => initialState)
        .addCase(
            fetchShippingRegion.fulfilled,
            (state, action): string => action.payload.data.region || state,
        );
});
